import { IFolderSortSettings } from 'models/folder.model'

export enum sortFolderEnum {
  asc = 'asc',
  desc = 'desc',
}

export const advancedOrder = 'advancedOrder'

export const sortFolderDefault = sortFolderEnum.asc

export const sortSettingsDefault: IFolderSortSettings = {
  fields: [{ attribute: 'advance', direction: sortFolderDefault }],
}
